var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKuwait(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.654 16.6259C24.1363 15.3259 24.4004 13.9198 24.4004 12.452C24.4004 10.9842 24.1363 9.57809 23.654 8.2781L12.4004 7.23462L1.14678 8.2781C0.664438 9.57809 0.400391 10.9842 0.400391 12.452C0.400391 13.9198 0.664438 15.3259 1.14678 16.6259L12.4004 17.6694L23.654 16.6259Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4001 24.4518C17.5597 24.4518 21.9582 21.1953 23.6537 16.6257H1.14648C2.84205 21.1953 7.24052 24.4518 12.4001 24.4518Z",
    fill: "#D80027"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4001 0.451904C7.24052 0.451904 2.84205 3.7084 1.14648 8.27801H23.6538C21.9582 3.7084 17.5597 0.451904 12.4001 0.451904Z",
    fill: "#6DA544"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9151 3.96655C-0.77118 8.65283 -0.77118 16.2508 3.9151 20.9372C5.13831 19.714 6.33221 18.5201 8.22648 16.6258V8.27797L3.9151 3.96655Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKuwait);
export default __webpack_public_path__ + "static/media/Kuwait.89e7e8e191c092da40ee3e39d8a35d1e.svg";
export { ForwardRef as ReactComponent };